import React, { useEffect } from "react";
import arrow from "../../Assets/Images/arrow.svg";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useProducts } from "../../Context/ProductsContext";
import { useTranslation } from "react-i18next";
import { initialLanguage } from "../../Consts";

const responsive = {
  largeDesktop: { breakpoint: { max: 4000, min: 1600 }, items: 5 },
  desktop: { breakpoint: { max: 1600, min: 1200 }, items: 4 },
  tablet: { breakpoint: { max: 1199, min: 768 }, items: 3 },
  smallTablet: { breakpoint: { max: 1024, min: 768 }, items: 3 },
  mobile: { breakpoint: { max: 768, min: 576 }, items: 3 },
  smallMobile: { breakpoint: { max: 575, min: 0 }, items: 1 },
};

function SectionOne() {
  const { t } = useTranslation();
  const { getProducts, isProducts } = useProducts();

  useEffect(() => {
    getProducts();
  }, []);

  const products = isProducts?.data || [];

  // لو اللغة عربية نعكس المصفوفة بحيث يبدأ الكاروسيل من اليمين
  const productsToShow = initialLanguage === "ar" ? [...products].reverse() : products;

  return (
    <div className="flex flex-col gap-5 w-full">
      {/* header */}
      <div className="flex justify-between items-center"
        data-aos="fade-in"
        data-aos-duration="1000"
        data-aos-easing="linear"
        data-aos-delay="500">
        <h1 className="text-[#0A66B0] font-semibold" style={{ fontSize: "clamp(2rem, 2.25vw, 4rem)" }}>
          {t("Products")}
        </h1>
        <Link to="/products/all" className="flex items-center gap-2 text-[#AAAAAA] font-semibold"
          style={{ fontSize: "clamp(1rem, 1vw, 4rem)" }}
          state={{ id: 'all' }}>
          {t("View All")}
          <img
            src={arrow}
            alt=""
            className={initialLanguage === "ar" ? "flip-horizontal w-[1rem] h-[1rem]" : "w-[1rem] h-[1rem]"}
          />
        </Link>
      </div>

      {/* carousel */}
      {productsToShow.length > 0 ? (
        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3000}
          showDots={false}
          arrows
          containerClass={`carousel-container relative z-0 ${initialLanguage === "ar" ? "rtl-carousel" : ""}`}
          itemClass="px-3"
          // لو المكتبة تدعم rtl — خليه true للعربية
          rtl={initialLanguage === "ar"}
          // تأكد أن اتجاه الحاوية نفسه rtl
          style={{ direction: initialLanguage === "ar" ? "rtl" : "ltr" }}
        >
          {productsToShow.map((product) => (
            <div key={product.id} className="flex gap-[2rem] lg:gap-10 overflow-hidden">
              <div
                data-aos={initialLanguage === "ar" ? "fade-right" : "fade-left"}
                data-aos-duration="1000"
                data-aos-easing="linear"
                data-aos-delay="500"
                className={`relative group flex flex-col items-start gap-[15px] w-full lg:w-[25vw] ${initialLanguage === "ar" ? "text-right" : "text-left"}`}
              >
                <div className="rounded-md overflow-hidden">
                  <Link to={`/product/${product.slug}`}>
                    <img
                      src={product.image_url}
                      alt=""
                      className="w-full h-[45vw] md:h-[25vw] lg:h-[20vw] xl:h-[16vw] rounded-md object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-110"
                    />
                  </Link>
                </div>

                <h1 className="text-[#212121] group-hover:text-[#0A66B0] transition-colors duration-300"
                  style={{ fontSize: "clamp(1.1rem, 1.1vw, 4rem)" }}>
                  {product.title}
                </h1>
              </div>
            </div>
          ))}
        </Carousel>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default SectionOne;
